import React from 'react';
import { useAppContext } from 'components/Context/AppContext';
import { Button, InputField } from 'components/Global';
import { ReactComponent as ReuploadIcon } from 'icons/reupload-icon.svg';
import ImageViewer from 'components/Global/ImageViewer';
import { getKTPValue } from 'utils/functionality';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import ImageNotAvailable from 'components/Global/ImageNotAvailable';

const DetailPenyewa = ({ data, customer, selectedCountry, imagePreviewHandler, approvalUpdate }) => {
  const { setShowReviewIdentityModal } = useAppContext();

  const isUploadNewDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, 'anonymous');
  const isB2BPartnerIntegrationEnabled = useFliptBoolean('ENABLE_B2B_PARTNER_INTEGRATION', false, 'anonymous');
  const isVendorOrder = Boolean(data?.vendor_partnership_id);

  return (
    <div className="detail-order-with-driver__renter-detail">
      <div className="detail-order-with-driver__renter-detail-title">
        <h1>Detail Penyewa</h1>
      </div>
      <div className="detail-order-with-driver__renter-detail-body">
        <InputField label="Nama Lengkap" disabled value={data?.user_name || '-'} />
        <InputField label="Email" disabled value={data?.email || '-'} />

        <div className="detail-order-with-driver__renter-detail-body__phone-number">
          <InputField
            label="No Handphone"
            disabled
            value={data?.phone_country_code || '-'}
            icon={
              <img
                src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                width={26}
                height={16}
                alt={selectedCountry?.name + ' nation flag'}
              />
            }
          />
          <InputField value={data?.phone_number || '-'} disabled />
        </div>

        <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

        <div className="detail-order-with-driver__renter-detail-body__phone-number">
          <div className="detail-order-with-driver__renter-detail-body__phone-number-wrapper">
            <InputField
              label="Whatsapp"
              disabled
              value={data?.phone_country_code || '-'}
              icon={
                <img
                  src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                  width={26}
                  height={16}
                  alt={selectedCountry?.name + ' nation flag'}
                />
              }
            />
            <div className="detail-order-with-driver__renter-detail-body__image-wrapper"></div>
          </div>
          <InputField disabled value={data?.wa_number || '-'} />
        </div>

        <div />

        <div className="detail-order__payment-detail-body__preview-image">
          {isB2BPartnerIntegrationEnabled && isVendorOrder ? (
            <ImageNotAvailable label="KTP" />
          ) : (
            <ImageViewer
              label="KTP"
              value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
              onClick={imagePreviewHandler}
              customButton={
                (data?.order_status === 'PAID' || data?.order_status === 'REVIEWING_IDENTITY') &&
                !approvalUpdate && (
                  <>
                    <Button type="button" onClick={() => setShowReviewIdentityModal({ type: 'ktp', show: true })}>
                      Tinjau
                    </Button>
                    {customer?.PersonalInfos?.need_review_ktp && (
                      <div className="reupload-icon">
                        <ReuploadIcon />
                        <p>Upload ulang KTP</p>
                      </div>
                    )}
                  </>
                )
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailPenyewa;
